import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { sharedGet } from "@/lib/http";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n/I18nContext";

// Friends icon with unread badge. Polls /client/friends/unread every 20s.
export default function FriendsIconLink() {
  const { user } = useAuth();
  const { t } = useT();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user || user.role !== "client") return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await sharedGet("/client/friends/unread");
        if (!cancelled) setUnread(data?.count || 0);
      } catch {}
    };
    poll();
    const iv = setInterval(poll, 20000);
    return () => { cancelled = true; clearInterval(iv); };
  }, [user]);

  const label = t("nav.friends") || "Friends";

  return (
    <NavLink
      to="/app/amici"
      data-testid="mobile-friends-link"
      className="relative h-8 w-8 rounded-full bg-[#5A8B8F]/10 text-[#2C5254] flex items-center justify-center hover:bg-[#5A8B8F]/20 transition"
      aria-label={label}
      title={label}
    >
      <UserPlus className="h-3.5 w-3.5" />
      {unread > 0 && (
        <span
          data-testid="friends-unread-badge"
          className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-[#E8951C] text-white text-[10px] font-bold flex items-center justify-center"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </NavLink>
  );
}
